import { Card, Text } from "@overmap-ai/blocks"
import { type FormIdentifierValue, type Stored } from "@overmap-ai/common"
import { selectFormIdentifierById, selectUserById } from "@overmap-ai/core"
import { memo } from "react"

import { FormSubmissionTimelineItemType } from "../../enums/forms"
import { formSubmissionTimelineItemTypeData } from "../../mappings/forms"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"
import type { FormSubmissionTimelineSize } from "./typings"

interface FormSubmissionIdentifierValueTimelineItemProps {
	formIdentifierValue: Stored<FormIdentifierValue>
	size: FormSubmissionTimelineSize
}

export const FormSubmissionIdentifierValueTimelineItem = memo<FormSubmissionIdentifierValueTimelineItemProps>(
	(props) => {
		const { formIdentifierValue, size } = props

		const createdBy = useAppSelector(selectUserById(formIdentifierValue.created_by ?? -1))
		const identifier = useAppSelector(selectFormIdentifierById(formIdentifierValue.form_identifier))!
		const { icon } = formSubmissionTimelineItemTypeData[FormSubmissionTimelineItemType.IDENTIFIER_VALUE]

		return (
			<div className="flex h-max w-full gap-4">
				<TimelineIconRail icon={icon} size={size} />
				<Card className="flex min-w-0 grow flex-col gap-1" size={size}>
					<Text size={size} accentColor="base">
						<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
						&nbsp;updated identifier
						<Text accentColor="base">
							&nbsp;&#8226;&nbsp;{formatCompactDate(formIdentifierValue.submitted_at)}
						</Text>
					</Text>
					<Text accentColor="base" className="min-w-0 truncate" size={size}>
						<Text highContrast>{identifier.name}</Text>
						&nbsp;to&nbsp;
						<Text highContrast>{formIdentifierValue.value}</Text>
					</Text>
				</Card>
			</div>
		)
	},
)
FormSubmissionIdentifierValueTimelineItem.displayName = "FormSubmissionIdentifierValueTimelineItem"
